/*
 * Publication Page Messages
 *
 * This contains all the text for the Publication Page components.
 */
import { defineMessages } from 'react-intl';

const scope = 'app.workspace.publications';

export default defineMessages({
  getStarted: {
    id: `${scope}.getStarted`,
    defaultMessage: 'Add Title',
  },

  create: {
    id: `${scope}.create`,
    defaultMessage: 'You have not published any content in this workspace yet. To begin publishing, add a title to this page.',
  },

  ADD: {
    id: `${scope}.ADD`,
    defaultMessage: 'ADD',
  },

  title: {
    id: `${scope}.publications`,
    defaultMessage: 'Publications',
  },

  publications: {
    id: `${scope}.publications`,
    defaultMessage: 'Publications',
  },

  coursePresent: {
    id: `${scope}.coursePresent`,
    defaultMessage: 'Course already added, please proceed to publish',
  },
  selectButton: {
    id: `${scope}.selectButton`,
    defaultMessage: 'Select',
  },
});
